// Specializaion
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Especialização', true, 'professional')),
  route('create', '/create', Form, professionalMeta('Adicionar Especialização', true, 'professional')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Especialização', true, 'professional'))
]

export default subGroup('/specializations', routes)



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/routes.js